const publications = [
  {
    id: 'trademark-registration-masterclass-2024',
    title: 'Trademark Registration Masterclass 2024',
    description: 'Complete step-by-step training program covering every aspect of trademark registration from initial concept to final certificate.',
    type: 'eBook',
    pages: '68 pages',
    size: '5.4 MB',
    featured: true,
    image: 'https://images.unsplash.com/photo-1634133519007-51b0f57ba945?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxlZHVjYXRpb24lMjBlYm9vayUyMGxlYXJuaW5nJTIwc3R1ZHklMjBndWlkZSUyMHRleHRib29rfGVufDB8fHx8MTc3NTc2MjY3NHww&ixlib=rb-4.1.0&q=85',
    content: `This comprehensive eBook covers everything you need to know about trademark registration in the United States.

## What You'll Learn

### Chapter 1: Understanding Trademarks
- What qualifies as a trademark
- Types of marks: word marks, design marks, combined marks
- The trademark strength spectrum
- Common law vs. federal registration

### Chapter 2: Preparing to File
- Conducting a comprehensive trademark search
- Choosing the right filing basis (use in commerce vs. intent-to-use)
- Understanding the Nice Classification system
- Selecting the right goods and services descriptions

### Chapter 3: The Application Process
- Creating a USPTO.gov account
- Choosing between TEAS Plus and TEAS Standard
- Required information and specimens
- Filing fees and payment options

### Chapter 4: After Filing
- Understanding the examination process
- Responding to office actions
- The publication and opposition period
- Statement of use requirements

### Chapter 5: Maintaining Your Trademark
- Section 8 declarations (years 5-6)
- Section 9 renewal applications (every 10 years)
- Monitoring and enforcement strategies
- International expansion considerations

This guide is designed for business owners, entrepreneurs, and anyone looking to understand the trademark registration process from start to finish.`
  },
  {
    id: 'brand-protection-strategies-digital-commerce',
    title: 'Brand Protection Strategies for Digital Commerce',
    description: 'Essential tactics for safeguarding your brand in online marketplaces, e-commerce platforms, and digital channels.',
    type: 'Whitepaper',
    pages: '42 pages',
    size: '3.8 MB',
    featured: true,
    image: 'https://images.unsplash.com/photo-1775163024488-e88e4a71179f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxjb250cmFjdCUyMHJldmlldyUyMGRvY3VtZW50JTIwYnVzaW5lc3MlMjBwcm9mZXNzaW9uYWwlMjBkZXNrfGVufDB8fHx8MTc3NTc2MjY2MXww&ixlib=rb-4.1.0&q=85',
    content: `As e-commerce continues to grow, protecting your brand in digital channels has become more critical than ever. This whitepaper provides actionable strategies for comprehensive digital brand protection.

## Key Topics Covered

### Online Marketplace Protection
- Amazon Brand Registry enrollment and optimization
- eBay VeRO program utilization
- Walmart Brand Portal strategies
- Etsy IP protection tools

### Social Media Brand Defense
- Securing brand handles across platforms
- Dealing with impersonation accounts
- Managing user-generated content
- Platform-specific reporting procedures

### Domain Name Strategy
- Comprehensive domain portfolio management
- UDRP proceedings for cybersquatting
- Defensive domain registration strategies
- ccTLD protection considerations

### Digital Advertising Protection
- Keyword trademark policies on Google Ads
- Social media advertising IP concerns
- Competitor bidding on branded terms
- Affiliate marketing trademark guidelines

### Technology Solutions
- AI-powered brand monitoring tools
- Digital watermarking and authentication
- Blockchain-based brand verification
- Automated enforcement platforms

This whitepaper is essential reading for any business with an online presence looking to protect their brand from digital threats.`
  },
  {
    id: 'uspto-filing-guide-complete-walkthrough',
    title: 'USPTO Filing Guide: Complete Walkthrough',
    description: 'Comprehensive instructions for navigating the USPTO filing system with expert tips to avoid common mistakes and delays.',
    type: 'Guide',
    pages: '55 pages',
    size: '4.7 MB',
    image: 'https://images.unsplash.com/photo-1743017524261-f026c51acf7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxsZWdhbCUyMGFkdmlzb3IlMjBsYXclMjBmaXJtJTIwY29uc3VsdGF0aW9ufGVufDB8fHx8MTc3NTc2MjYzNnww&ixlib=rb-4.1.0&q=85',
    content: `Navigate the USPTO trademark filing system with confidence using this step-by-step guide. Includes screenshots, tips, and expert advice to ensure your application is filed correctly the first time.

## Guide Contents

### Getting Started
- Creating your USPTO.gov account
- Understanding TEAS filing options
- Required documents and information checklist
- Filing fee breakdown and payment methods

### The Filing Process
- Step-by-step application walkthrough
- Selecting goods and services descriptions
- Uploading specimens of use
- Common filing mistakes and how to avoid them

### After Filing
- Tracking your application status
- Understanding examination timelines
- Preparing for potential office actions
- The publication and registration process

This guide includes real-world examples and expert commentary to help you navigate every step of the USPTO filing process.`
  },
  {
    id: 'startup-trademark-essentials-handbook',
    title: 'Startup Trademark Essentials Handbook',
    description: 'Everything new entrepreneurs need to know about protecting their brand from day one, with budget-friendly strategies.',
    type: 'eBook',
    pages: '48 pages',
    size: '4.1 MB',
    image: 'https://images.unsplash.com/photo-1758873272783-3e4996938595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxzdGFydHVwJTIwZW50cmVwcmVuZXVyJTIwd29ya2luZyUyMGxhcHRvcCUyMHBsYW5uaW5nfGVufDB8fHx8MTc3NTc2MjY0NHww&ixlib=rb-4.1.0&q=85',
    content: `Starting a business is exciting, but many entrepreneurs overlook one of the most important steps: protecting their brand. This handbook gives startups everything they need to know about trademark protection on a budget.

## What's Inside

### Why Startups Need Trademarks
- The cost of NOT registering
- Real-world horror stories from unprotected startups
- How trademarks increase company valuation
- Investor expectations for IP protection

### Budget-Friendly Protection Strategies
- Prioritizing what to protect first
- DIY vs. professional filing
- Intent-to-use applications for pre-launch brands
- Free and low-cost monitoring tools

### Common Startup Mistakes
- Choosing a descriptive or generic name
- Not searching before investing in branding
- Filing in the wrong trademark classes
- Ignoring international protection

### Building Your IP Portfolio
- When to file additional trademarks
- Copyright protection for startup content
- Trade secret basics for tech startups
- Patent considerations for innovative products

Essential reading for every founder, from idea stage to Series A and beyond.`
  },
  {
    id: 'international-brand-protection-framework',
    title: 'International Brand Protection Framework',
    description: 'Navigate global trademark registration with this comprehensive guide to the Madrid Protocol and international filing systems.',
    type: 'eBook',
    pages: '72 pages',
    size: '6.2 MB',
    image: 'https://images.unsplash.com/photo-1556122492-766a8b354a16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxnbG9iYWwlMjBpbnRlcm5hdGlvbmFsJTIwYnVzaW5lc3MlMjB3b3JsZCUyMG1hcCUyMGdsb2JlfGVufDB8fHx8MTc3NTc2MjY3NHww&ixlib=rb-4.1.0&q=85',
    content: `Expanding your brand internationally? This comprehensive guide covers everything you need to know about protecting your trademark in global markets.

## Guide Contents

### The Madrid Protocol System
- How the Madrid system works
- Filing through WIPO
- Designating countries
- Managing your international portfolio

### Regional Systems
- European Union Trademark (EUTM)
- African Regional Intellectual Property Organization (ARIPO)
- Benelux Office for Intellectual Property
- Other regional filing options

### Country-Specific Considerations
- First-to-file vs. first-to-use jurisdictions
- Translation and transliteration requirements
- Local agent requirements
- Cultural and linguistic considerations

### Enforcement Across Borders
- Cross-border enforcement strategies
- Working with local counsel
- Customs recordation programs
- International arbitration options

This guide is essential for any business planning international expansion or selling products in global markets.`
  },
  {
    id: 'trademark-enforcement-playbook',
    title: 'Trademark Enforcement Playbook',
    description: 'Proven strategies for monitoring, detecting, and taking action against trademark infringement with template letters and legal frameworks.',
    type: 'Whitepaper',
    pages: '38 pages',
    size: '3.5 MB',
    image: 'https://images.unsplash.com/photo-1767972159674-460283907c21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxsZWdhbCUyMGdhdmVsJTIwY291cnRyb29tJTIwbGF3JTIwanVzdGljZXxlbnwwfHx8fDE3NzU3NjI2NDR8MA&ixlib=rb-4.1.0&q=85',
    content: `Protecting your trademark doesn't end at registration. This playbook provides proven strategies and templates for monitoring and enforcing your trademark rights.

## Playbook Contents

### Monitoring Strategies
- Setting up comprehensive brand monitoring
- Tools and services for trademark watching
- Social media monitoring best practices
- E-commerce marketplace surveillance

### Enforcement Actions
- Cease and desist letter templates
- DMCA takedown request procedures
- Platform-specific reporting guides
- TTAB opposition and cancellation proceedings

### Litigation Preparation
- When to escalate to litigation
- Building your infringement case
- Calculating damages
- Alternative dispute resolution options

### Prevention Strategies
- Proactive brand protection measures
- Employee and partner education
- Licensing best practices
- Co-existence agreements

Includes ready-to-use templates and checklists for immediate implementation.`
  },
];

export const publicationTypes = ['All', 'eBook', 'Whitepaper', 'Guide'];

export default publications;
